<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" sm="8" md="6">
        <!-- <v-card class="">
          <v-row justify="center">
            <v-img src="/assets/logo-hc-white.png" height="300" width="300" contain class="bg-primary"
              alt="HC Logo"></v-img>
          </v-row>
        </v-card> -->
        <v-card class="elevation-12 vcard-logo">
          <!-- <v-toolbar color="primary" dark flat class="d-flex flex-column align-center">
            <v-toolbar-title class="d-flex flex-row justify-center">Iniciar sesión</v-toolbar-title>
          </v-toolbar> -->

          <v-card-text>
            <v-form @submit.prevent="login" ref="form">
              <v-text-field
                v-model="username"
                label="Usuario"
                name="username"
                prepend-icon="mdi-account"
                :rules="[(v) => !!v || 'El usuario es requerido']"
                required
              ></v-text-field>

              <v-text-field
                v-model="password"
                label="Contraseña"
                name="password"
                prepend-icon="mdi-lock"
                type="password"
                :rules="[(v) => !!v || 'La contraseña es requerida']"
                required
              ></v-text-field>
              <v-radio-group v-model="hotel" row inline>
                <v-radio label="Barcelona" value="B"></v-radio>
                <v-radio label="Palacete" value="P"></v-radio>
              </v-radio-group>
              <v-card-actions>
                <v-btn type="submit" class="bg-info" :loading="loading" block>
                  Iniciar sesión
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbar" :color="snackbarColor" timeout="3000">
      {{ snackbarText }}
    </v-snackbar>
  </v-container>
</template>

<script setup>
import { ref, defineComponent } from 'vue'
import { useAuthStore } from '@/stores/authStore'
import { useRouter } from 'vue-router'

const authStore = useAuthStore()
const router = useRouter()
const form = ref(null)
const username = ref('')
const password = ref('')
const hotel = ref('B') // Valor por defecto: Barcelona
const loading = ref(false)
const snackbar = ref(false)
const snackbarText = ref('')
const snackbarColor = ref('success')
defineComponent({
  name: 'LoginForm'
})
const login = async () => {
  if (form.value.validate()) {
    loading.value = true
    try {
      await authStore.login({
        username: username.value,
        password: password.value,
        hotel: hotel.value
      })
      // Actualizar el estado en App.vue a través del store
      authStore.setAppReady(true) // Necesitaremos añadir este método al store

      snackbarText.value = 'Inicio de sesión exitoso'
      snackbarColor.value = 'success'
      snackbar.value = true
      router.push('/') // Redirige a la página principal después del login
    } catch (error) {
      snackbarText.value =
        'Error al iniciar sesión: ' +
        (error.response?.data?.message || error.message)
      snackbarColor.value = 'error'
      snackbar.value = true
    } finally {
      loading.value = false
    }
  }
}
</script>
